import { MOTE_CARD_THEME } from '@mote/helpers/constants'
import {
  ReactionsContextProvider,
  convertToListeningContext
} from '@mote/recipes'
import { MotePlayerProviders } from '../../shared/components'
import { MoteCardRich } from './MoteCardRich'

export const MoteCardRichWrapper = ({
  moteId,
  theme = 'classic',
  isStandalone = true,
  isLandingPage = false,
  isEmbed = false,
  myReactions = [],
  ...props
}) => {
  return (
    <MotePlayerProviders
      moteId={moteId}
      moteCreatedByUserId={props.createdByUserId}
      theme={MOTE_CARD_THEME[theme]}
      isStandalone={isStandalone}
      isLandingPage={isLandingPage}
      isEmbed={isEmbed}
      audioSource={props.audioUrl}
      isRichCard
    >
      <ReactionsContextProvider
        listeningContext={convertToListeningContext(isLandingPage, isEmbed)}
        myReactions={myReactions}
        id={moteId}
        createdByUserId={props.createdByUserId}
      >
        <MoteCardRich isStandalone={isStandalone} {...props} />
      </ReactionsContextProvider>
    </MotePlayerProviders>
  )
}
